import React from 'react';
import { motion } from 'framer-motion';
import { Target } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-167">
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-[100px] pointer-events-none transform -translate-y-1/2" data-id="element-168" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-[#1A1A1A] to-[#141414] p-10 md:p-16 rounded-3xl border border-amber-500/20 shadow-[0_0_50px_rgba(245,158,11,0.05)] text-center" data-id="element-170">
          <div className="inline-flex justify-center items-center w-20 h-20 rounded-2xl bg-amber-500/10 text-amber-500 mb-8 rotate-3" data-id="element-171">
            <Target className="w-10 h-10" data-id="element-172" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 tracking-tight" data-id="element-173">
            Te presento la{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-174">
              IA Simplificada
            </span>
          </h2>

          <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-175">
            Una metodología que traduce la inteligencia artificial en pasos
            simples. Sin código, sin términos complicados. Un sistema paso a
            paso para automatizar tus procesos en 48 horas, usando herramientas
            que ya existen y sin necesidad de experiencia técnica.
          </p>
        </motion.div>
      </div>
    </section>;
}